import { render, staticRenderFns } from "./UserManagePermissions.vue?vue&type=template&id=97156cf2&scoped=true"
import script from "./UserManagePermissions.vue?vue&type=script&lang=js"
export * from "./UserManagePermissions.vue?vue&type=script&lang=js"
import style0 from "./UserManagePermissions.vue?vue&type=style&index=0&id=97156cf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97156cf2",
  null
  
)

export default component.exports